import Cookies from 'js-cookie';

const API_BASE = 'https://system.sales-management.cloud/api';
const TESTS_API = `${API_BASE}/tests.php`;
const TESTS_QUESTION_API = `${API_BASE}/tests_question.php`;
const TESTS_ANSWER_API = `${API_BASE}/tests_answer.php`;
const TESTS_HISTORY_API = `${API_BASE}/tests_history.php`;
const ADMIN_TEST_THEMES_API = `${API_BASE}/admin/test-themes.php`;
const ADMIN_TEST_HISTORY_API = `${API_BASE}/admin/test-history.php`;

function getAuthHeaders(includeContentType = false) {
  const token = Cookies.get('auth_token');
  const headers = {
    Authorization: token ? `Bearer ${token}` : '',
  };

  if (includeContentType) {
    headers['Content-Type'] = 'application/json';
  }

  return headers;
}

async function parseResponse(response) {
  const json = await response.json();
  if (!response.ok || json.status !== 'success') {
    const message = json?.message || 'APIリクエストに失敗しました';
    throw new Error(message);
  }
  return json;
}

export async function fetchTests() {
  const response = await fetch(TESTS_API, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
  return parseResponse(response);
}

export async function generateQuestion(themeId) {
  const url = `${TESTS_QUESTION_API}?theme_id=${Number(themeId)}`;
  const maxAttempts = 3;

  for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
    const response = await fetch(url, {
      method: 'GET',
      headers: getAuthHeaders(),
    });

    let json = null;
    try {
      json = await response.json();
    } catch (err) {
      if (attempt < maxAttempts) {
        await new Promise((resolve) => setTimeout(resolve, 300 * attempt));
        continue;
      }
      throw err;
    }

    if (response.ok && json?.status === 'success') {
      return json;
    }

    if (response.status === 429 && attempt < maxAttempts) {
      await new Promise((resolve) => setTimeout(resolve, 700 * attempt));
      continue;
    }

    throw new Error(json?.message || 'APIリクエストに失敗しました');
  }

  throw new Error('問題生成の再試行に失敗しました');
}

export async function submitAnswer(themeId, payload) {
  const response = await fetch(`${TESTS_ANSWER_API}?theme_id=${Number(themeId)}`, {
    method: 'POST',
    headers: getAuthHeaders(true),
    body: JSON.stringify(payload),
  });
  return parseResponse(response);
}

export async function fetchTestHistory(params = {}) {
  const searchParams = new URLSearchParams();
  if (params.limit) searchParams.set('limit', String(params.limit));
  if (params.offset) searchParams.set('offset', String(params.offset));
  if (params.theme_id) searchParams.set('theme_id', String(params.theme_id));

  const url = searchParams.toString()
    ? `${TESTS_HISTORY_API}?${searchParams.toString()}`
    : TESTS_HISTORY_API;

  const response = await fetch(url, {
    method: 'GET',
    headers: getAuthHeaders(),
  });

  return parseResponse(response);
}

export async function fetchAdminTestThemes() {
  const response = await fetch(ADMIN_TEST_THEMES_API, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
  return parseResponse(response);
}

export async function fetchAdminTestHistory(params = {}) {
  const searchParams = new URLSearchParams();
  if (params.user_id) searchParams.set('user_id', String(params.user_id));
  if (params.theme_id) searchParams.set('theme_id', String(params.theme_id));
  if (params.limit) searchParams.set('limit', String(params.limit));
  if (params.offset !== undefined) searchParams.set('offset', String(params.offset));
  if (params.search) searchParams.set('search', String(params.search));
  if (params.users_limit) searchParams.set('users_limit', String(params.users_limit));

  const url = searchParams.toString()
    ? `${ADMIN_TEST_HISTORY_API}?${searchParams.toString()}`
    : ADMIN_TEST_HISTORY_API;

  const response = await fetch(url, {
    method: 'GET',
    headers: getAuthHeaders(),
  });

  return parseResponse(response);
}

export async function createAdminTestTheme(payload) {
  const response = await fetch(ADMIN_TEST_THEMES_API, {
    method: 'POST',
    headers: getAuthHeaders(true),
    body: JSON.stringify(payload),
  });
  return parseResponse(response);
}

export async function updateAdminTestTheme(payload) {
  const response = await fetch(ADMIN_TEST_THEMES_API, {
    method: 'PUT',
    headers: getAuthHeaders(true),
    body: JSON.stringify(payload),
  });
  return parseResponse(response);
}

export async function deleteAdminTestTheme(id) {
  const response = await fetch(`${ADMIN_TEST_THEMES_API}?id=${Number(id)}`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });
  return parseResponse(response);
}
